module.exports = __webpack_public_path__ + "static/thumb_width_unicef_img1@2x-43d76db81aef367c5c1fdb346cd0ab28.jpg";